<template>
    <div>
    </div>
</template>

<script>

    import {Toast} from 'vant'
    import Vue from 'vue';
    import Cookies from 'js-cookie'
    import {isLogin} from '@/utils/commonUtils'

    Vue.use(Toast);

    export default {
        name: "auth",
        created() {
            const currentUrl = Cookies.get('currentUrl')
            if (currentUrl) {
                if (isLogin()){
                    Toast.loading({
                        mask: true,
                        message: '授权中...'
                    });
                    this.$axios.get("/jump/authLogin", {params: {currentUrl: currentUrl}}).then(res => {
                        Cookies.remove("currentUrl")
                        if (res.data) {
                            Toast.clear();
                            window.location.href = res.data
                        }
                    }).catch(err => {
                        Cookies.remove("currentUrl")
                    });
                }else {
                    Toast.loading({
                        mask: true,
                        message: '加载中...'
                    });
                    this.$router.push({path: '/login', query: {redirectUrl: this.$route.path}})
                    Toast.clear();
                }
            }else{
                this.$router.push('/')
            }
        }
    }
</script>

<style scoped>

</style>
